import { useFigureCompositionStore } from '@/store/figure-composition';

export function GridSettings() {
  const { currentComposition, setGridSettings } = useFigureCompositionStore();

  if (!currentComposition) return null;

  const { grid } = currentComposition;

  const update = (partial: Partial<typeof grid>) => {
    setGridSettings(partial);
  };

  const handleColsChange = (value: string) => {
    const num = parseInt(value, 10);
    if (Number.isNaN(num) || num < 1 || num > 24) return;
    update({ cols: num });
  };

  const handleRowHeightChange = (value: string) => {
    const num = parseInt(value, 10);
    if (Number.isNaN(num) || num < 10 || num > 200) return;
    update({ rowHeight: num });
  };

  const handleMarginXChange = (value: string) => {
    const num = parseInt(value, 10);
    if (Number.isNaN(num) || num < 0 || num > 200) return;
    update({ margin: [num, grid.margin[1]] });
  };

  const handleMarginYChange = (value: string) => {
    const num = parseInt(value, 10);
    if (Number.isNaN(num) || num < 0 || num > 200) return;
    update({ margin: [grid.margin[0], num] });
  };

  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium">Grid</span>
      <div className="flex flex-col gap-2 text-xs">
        <div className="flex gap-2">
          <label className="flex items-center gap-1">
            <span>Cols</span>
            <input
              type="number"
              className="w-16 border rounded px-1 py-0.5"
              value={grid.cols}
              onChange={(e) => handleColsChange(e.target.value)}
            />
          </label>
          <label className="flex items-center gap-1">
            <span>Row height</span>
            <input
              type="number"
              className="w-20 border rounded px-1 py-0.5"
              value={grid.rowHeight}
              onChange={(e) => handleRowHeightChange(e.target.value)}
            />
          </label>
        </div>
        <div className="flex gap-2">
          <label className="flex items-center gap-1">
            <span>Margin X</span>
            <input
              type="number"
              className="w-16 border rounded px-1 py-0.5"
              value={grid.margin[0]}
              onChange={(e) => handleMarginXChange(e.target.value)}
            />
          </label>
          <label className="flex items-center gap-1">
            <span>Margin Y</span>
            <input
              type="number"
              className="w-16 border rounded px-1 py-0.5"
              value={grid.margin[1]}
              onChange={(e) => handleMarginYChange(e.target.value)}
            />
          </label>
        </div>
      </div>
    </div>
  );
}
